import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrl: './input.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class InputComponent implements ControlValueAccessor {

  @Input('value') _value: any;

  @Input() id?: string;
  @Input() label?: string;
  @Input() isRequiredLabel: boolean = false;
  @Input() type?: string = 'text';
  @Input() placeholder?: string;
  @Input() startIcon?: string;
  @Input() isReadOnly: boolean = false;
  @Input() maxLength: number = Number.MAX_SAFE_INTEGER;
  

  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
  }

  constructor() { }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

    // Local input change handler
  onInputChange(event: Event): void {
    const newValue = (event.target as HTMLInputElement).value;
    this.value = newValue;
    this.onChange(newValue); // Notify Angular forms of the change
  }
}
